import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getProductGrantResources} from 'src/openapi/admin/apis/ProductGrantResourcesApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    grantId: string,
    pageNumber: number,
    pageSize: number,
};

export const useProductsGrantResources = ({grantId, pageNumber, pageSize}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getProductGrantResources({grantId, pageNumber, pageSize}, {signal}),
    ), [grantId, pageNumber, pageSize, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: {
            grantId: '',
            resources: [],
            totalCount: 0,
        },
        getDispatchAction,
    });
};
